import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { MenuItem } from '@microsoft/fast-foundation';
import { badgeCounterDefinition } from '../../Badge';
import { ChameleonElementMixin } from '../../common/ChameleonElement';
export class MenuItemComponent extends ChameleonElementMixin(MenuItem) {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.handleChangeEvent = (_e) => {
            this.$emit('menuitemclick', null, { bubbles: true, cancelable: true });
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('change', this.handleChangeEvent);
        if (this.size === 'small') {
            this.setBadgeCounterSize();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('change', this.handleChangeEvent);
    }
    /**
     * If a BadgeCounter is placed in the `end` slot of a MenuItem, we need to
     * set it's size to `small` if the MenuItem's size is small as well for visual consistency.
     */
    setBadgeCounterSize() {
        const trailingElements = this.end.assignedElements();
        if (trailingElements.length !== 0) {
            for (const element of trailingElements) {
                if (element.tagName.toLocaleLowerCase() === badgeCounterDefinition.name) {
                    element.setAttribute('size', this.size);
                }
            }
        }
    }
}
__decorate([
    attr
], MenuItemComponent.prototype, "size", void 0);
